import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { groupAddMemberFollowResponse } from 'apollo/responses';
import { FeedKey, Group, ProfileSuggestion, useFollowMutation, UserFeedFollowFragment } from 'api';
import { AddUser, PaddedPaper } from 'components';
import { useNotify } from 'hooks';
import { groupMemberFollow } from 'apollo/reducers';
import { makeStyles } from '@material-ui/core/styles';

interface IProps {
  group: Group;
  members: UserFeedFollowFragment[];
}

const useStyles = makeStyles({
  root: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: 0,
  },
});

const AddMemberInput: FC<IProps> = ({ group, members }) => {
  const classes = useStyles();
  const notify = useNotify();
  const membersById = members.map(member => member.user_id);
  const { t } = useTranslation();

  const [followMutation] = useFollowMutation({
    onError: notify.mutationError,
  });

  function handleAddMember(targetUser: ProfileSuggestion) {
    const params = { source: group, targetUser };
    const optimisticResponse = groupAddMemberFollowResponse(params);

    return followMutation({
      variables: {
        id: group.id,
        key: FeedKey.Group,
        target_user_id: targetUser.id,
      },
      optimisticResponse,
      update: (cache, result) => {
        groupMemberFollow({
          name: 'addMember',
          cache,
          result,
          variables: { group },
        });
      },
    }).then(() => {
      const i18nValues = { name: targetUser.title, title: group.title };
      const message = t('groups:addMemberNotify', i18nValues);
      notify.info({ message });
    });
  }

  return (
    <PaddedPaper className={classes.root}>
      <Grid container>
        <Grid item xs={4}>
          <AddUser
            onChange={handleAddMember}
            exclusions={membersById}
            TextFieldProps={{ fullWidth: true, margin: 'none', label: null }}
          />
        </Grid>
      </Grid>
    </PaddedPaper>
  );
};

export default AddMemberInput;
